module.exports = __webpack_public_path__ + "static/media/heartSusp.d144988c.svg";